var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 220,
    viewBox: "0 0 323 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.481 256H48.8764V184.693H0.0863037L62.7771 40.8515C86.571 -13.3361 139.343 -47 200.481 -47C284.086 -47 352.086 20.9535 352.086 104.5C352.086 188.046 284.086 256 200.481 256ZM88.9504 215.954H200.481C261.97 215.954 312.012 165.946 312.012 104.5C312.012 43.054 261.97 -6.95374 200.481 -6.95374C155.573 -6.95374 116.902 17.4244 99.545 56.6948L98.3177 59.6982L61.2743 144.621H88.9504V215.929V215.954Z",
    fill: "#7DC6F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHead);
export default __webpack_public_path__ + "static/media/head.ebdf9e9e19d27a38631963accebed973.svg";
export { ForwardRef as ReactComponent };